import { useDispatch, useSelector } from "react-redux";
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { Accordion, AccordionItem, Button, Card, Dialog, Divider, Icon, InlineStatus, MessageBar, Subway, SubwayStop, Tooltip } from "../../spa-admin/SpaAdminScope";
import { AppDispatch,RootState } from "../../../root-redux/RootState";
import { useLocation } from "react-router";
import { subwayStatus, ValidationState } from "../../spa-admin/redux/ReleaseDashboard.redux";
import { useEffect, useState } from "react";

import './release-dashboard.css';
import { ReleaseConfDataGridRow } from "../../release-management/Configuration/ReleaseConfiguration";
import { Campaign, PreReleaseAssignment, PreReleaseStatus } from "../../../model/SPAModels/campaigns/campaign.Model";
import { SPA_30MINS_IN_MILLISECONDS, SPA_12HRS_IN_MILLISECONDS, CAMPAIGN_TARGETED_PIPELINE_FIELD, SPA_PRERELEASE_ASSIGNMENTS_TYPE, CampaignStatusEnum, SPA_WORKFLOW_TYPE, SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT } from "../SPAConstants";
import { Attribute } from "../../../model/preview-mergerule/Prediction.model";
import { getPreReleaseAssignments_uat, refreshPreReleaseAssignments_uat } from "../../../services/SPAAdmin/ReleaseDashboard.api";
import { getCampaignById } from "../../../services/SPAAdmin/CampaignById.api";
import { ConvertRecordsToCSV, GenerateExcelFileFromContent } from "../../../services/utils/ExcelHandler";
import { getConfigurationByIdandVersion_uat } from "../../release-management/Configuration/ConfigurationApi";
import { Spinner } from "../../../shared-components/loader/Spinner";

interface ILiveDashboardProps {
    env: 'DEV'|'UAT'|'PROD'|'ALL';
    viewState: boolean;
    releaseRows: ReleaseConfDataGridRow[];
    setViewState: React.Dispatch<React.SetStateAction<boolean>>
    onDeploy?: () => void;
    buttonText?: string;
}

enum SectionView {
    segmentView = 1,
    recsView = 2,
    preReleaseAssignmentsView = 3
}

const hasWorkflowDelayed = (processingStatus: any|undefined, modifiedOn: Date) => {
    const now = new Date();
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    const diffFlag = (utc.getTime() - (modifiedOn || utc).getTime()) > SPA_30MINS_IN_MILLISECONDS;
    return processingStatus == undefined && diffFlag;
}

const hasNebulaDelayed = (modifiedOn: Date) => {
    const now = new Date();
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    return (utc.getTime() - (modifiedOn || utc).getTime()) > SPA_12HRS_IN_MILLISECONDS;
}

const getNextETA = (modifiedOn: Date) => {
    const now = new Date();
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    const diff = utc.getTime() - (modifiedOn || utc).getTime();
    const hours = Math.floor(diff / 3600000);
    const attempt = Math.floor(hours/4)+1;
    return `${attempt === 1 ? "1st" : attempt === 2 ? "2nd" : "3rd"} refresh is in ${4-(hours%4)} hour's`;
}

    // Checks if PreRelease assignment has any issue
    const hasPreReleaseIssue = (campaign: Campaign) => {
    const preReleaseInProgressInfo = campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE && info.status === PreReleaseStatus.IN_PROGRESS);
    
    if (preReleaseInProgressInfo && preReleaseInProgressInfo.modifiedDate) {
        const preReleaseInitiatedDate= new Date(preReleaseInProgressInfo.modifiedDate);
        const now = new Date();
        const ago = new Date(now.getTime() - (15 * 60 * 1000)); // 15 minutes ago

        const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
        const diffFlag = (utc.getTime() - (preReleaseInitiatedDate || utc).getTime()) > (15 * 60 * 1000); // 15 minutes in milliseconds

        return diffFlag;
    }
    
        return false;
    };
const RenderSubwayStatus = (env: 'DEV'|'UAT'|'PROD'|'ALL',relConfiguration:Campaign, subwayStatus: subwayStatus, setIsDeploy: any, modifiedOn: Date, inCartLength: number, postDeployInfo?: any[], releaseStatus?: string) => {

    const [sectionViewState, setSectionView] = useState<SectionView>(SectionView.segmentView);

    const dispatch = useDispatch<AppDispatch>();

    const ValidationStatus = (postDeployInfo || []).find((x: any) => x.type === 1);
    const ValidationWorkflowStatus = releaseStatus !== "Deployed" ? 0 :
                                     hasWorkflowDelayed(ValidationStatus, modifiedOn) ? 1 :
                                     ValidationStatus == undefined ? 2 :
                                     Object.keys(ValidationStatus).length > 0 && ValidationStatus.error == null ? 3 : 4;

    const PreProcessingStatus = (postDeployInfo || []).find((x: any) => x.type === 2);
    const PreProcessingWorkflowStatus = releaseStatus !== "Deployed" ? 0 :
                                        hasWorkflowDelayed(PreProcessingStatus, modifiedOn) ? 1 :
                                        PreProcessingStatus == undefined ? 2 :
                                        Object.keys(PreProcessingStatus).length > 0 && PreProcessingStatus.error == null ? 3 : 4;

    const isCampaignHasRecs = releaseStatus === "Deployed" && subwayStatus.recsStatus === 'complete' && ValidationWorkflowStatus === 3 && PreProcessingWorkflowStatus === 3;
    const allNebulaWorkflowValidation = subwayStatus.datasetValidationState === ValidationState.valid && subwayStatus.segmentValidationState === ValidationState.valid && 
                                        subwayStatus.sequenceValidationState === ValidationState.valid && ValidationWorkflowStatus === 3 && PreProcessingWorkflowStatus === 3;

    // const targetedPipeline = relConfiguration?.summary?.find((x: Attribute) => x.key === CAMPAIGN_TARGETED_PIPELINE_FIELD)?.value??0; 
    // const aboveTarget = (subwayStatus.pipeline?.total_potential_rev_base ?? 0) > (Number(targetedPipeline) || 0) ? true : false;

    //For PreAssignment Evaluation in UAT 
//For PreAssignment Evaluation in UAT 
    const campaign: Campaign = relConfiguration;
    
    // Get pre-release assignment data from redux store
    const assignmentsData = subwayStatus.preReleaseAssignments || [];
    const assignmentsStatus = campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status;
    
    // Determine if we can show generate button
    /**PreRelease dashboard statuses: 
     *  if recs have not yet generated - Waiting for the recs to be generated and segmented
     * Recs Gen, check for PreReleaseInfo Status - blank , not yet initiated - Show Generate PreAssignmens
     * Recs Gen, check for PreReleaseInfo Status - In Progress - Show the appropriate msg
     * Recs Gen, check for PreReleaseInfo Status - Published - Make GetPreReleaseAssignments call */

    const canGenerateAssignments = isCampaignHasRecs && !campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE);
    const isAssignmentsInProgress = campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status === PreReleaseStatus.IN_PROGRESS;
    const areAssignmentsPublished = assignmentsStatus === PreReleaseStatus.PUBLISHED;
    const campaignId = campaign?.config?.workflowId ? campaign.config.workflowId : '';
    const [showPreAssignmentSpinner, setShowPreAssignmentSpinner] = useState(false);

      // Handle generate pre-release assignments
    const handleGenerateAssignments = async () => {
        setShowPreAssignmentSpinner(true);
        if (campaignId) {
            await dispatch(refreshPreReleaseAssignments_uat({
                campaignId: campaignId,
                type: SPA_PRERELEASE_ASSIGNMENTS_TYPE
            }) as any);
            
            // Fetch the updated campaign data after generating assignments
            dispatch(getConfigurationByIdandVersion_uat({id:campaignId, version:relConfiguration.version.toString(),type:SPA_WORKFLOW_TYPE})).then((response: any) => {
                setShowPreAssignmentSpinner(false);
            });
        }
    };

    const handleDownloadAssignments = async () => {
        if (campaignId && areAssignmentsPublished && assignmentsData?.length > 0)
    {
            const filename = `pre-release-assignments-${campaignId}.csv`;
            let columns = Object.keys(assignmentsData[0]).map(key => ({ fieldName: key, displayName: key }));
            const records = assignmentsData.map((assignment: PreReleaseAssignment) => ({
                TPID: assignment.TPID,
                Alias: assignment.Alias,
                SegmentName: assignment.SegmentName,
                RoleName: assignment.RoleName,
                Priority: assignment.Priority,
                CampaignId: assignment.CampaignId,
                CampaignTag: assignment.CampaignTag,
                Version: assignment.Version
            })) as Record<string, string | number>[];
            columns = [...columns];

            // Create CSV content
        let csvContent = '';

        // Add headers as the first row
        csvContent = columns.map(column => column.displayName).join(',') + '\n';

        // Add data rows
        records.forEach(record => {
            const rowData: string[] = columns.map(key => {
                const attribute = record[key.fieldName as keyof typeof record];
                return attribute !== undefined ? `"${attribute}"` : '';
            });
            csvContent += rowData.join(',')  + '\n';
        });

     
        // Generate the Excel file

        GenerateExcelFileFromContent(csvContent, columns, filename);
    }
    
    };

      const renderPreReleaseAssignmentCardContent = () => {
 

        if (!isCampaignHasRecs) {
            return (
                <div className="cardContent">
                    <MessageBar>
                        Recommendations need to be generated first before creating pre-release assignments.
                    </MessageBar>
                </div>
            );
        }

        if (canGenerateAssignments) {
            return (
                <div className="cardContent">
                   {showPreAssignmentSpinner && <Spinner type="large" />}

                    <div style={{ marginBottom: '15px' }}>
                        <p>Recommendations are ready. You can now generate pre-release assignments to preview how recommendations will be Assigned in PROD.</p>
                    </div>
                    <Button 
                        appearance="primary"
                        onClick={handleGenerateAssignments} disabled={showPreAssignmentSpinner}
                    >
                        Generate Pre-Release Assignments
                    </Button>

                </div>
            );
        }

        if (isAssignmentsInProgress) {
           // Check for PreRelease issue first
            if (hasPreReleaseIssue(campaign)) {
                return (
            <div className="cardContent">
                <InlineStatus type="needs-attention">
                    <strong>Warning:</strong> Pre-release assignment generation may have encountered an issue. 
                    The assignment process has been running for more than 15 minutes. 
                    Please contact the CA engineering team for assistance or try regenerating the assignments.
                </InlineStatus>
                <Button 
                    appearance="secondary"
                    onClick={handleGenerateAssignments}
                    style={{ marginTop: '10px' }}
                    disabled={showPreAssignmentSpinner}
                >
                    Retry Generation
                </Button>
            </div>
        );
            }
            return (
                <div className="cardContent">
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                        <InlineStatus type="in-progress">Assignment generation in progress...</InlineStatus>
                    </div>
                    <p>Pre-release assignments are being generated. This may take a few minutes.</p>
                </div>
            );
        }

        if (areAssignmentsPublished && assignmentsData.length > 0) {
            return (
                <div className="cardContent">
                    {/* <div style={{ marginBottom: '15px' }}>
                        <InlineStatus type="complete">
                            {assignmentsData.length} assignments generated successfully
                        </InlineStatus>
                    </div> */}
                    
                    <div style={{ marginBottom: '15px' }}>
                        <p>Pre-release assignments have been generated. You can review the assignments below.</p>  
                        <p>
                            <strong>Note:</strong> These assignments are evaluated based on the production assignments data to provide a better preview of how recommendations will be distributed in the production environment.
                        </p>
                        {/** Showing randomly 10 records */}
                        {(() => {
                            const randomStart = assignmentsData.length > SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT
                                ? Math.floor(Math.random() * (assignmentsData.length - SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT))
                                : 0;
                            return (
                                <>
                                    <table className="segmentTableHeader" style={{ width: '100%' }}>
                                        <tr>
                                            <th>TPID</th>
                                            <th>Expected Owner</th>
                                            <th>Segment Name</th>
                                            <th>Role Name</th>
                                            <th>Priority</th>
                                        </tr>
                                        {assignmentsData.slice(randomStart, randomStart + SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT).map((assignment: PreReleaseAssignment, index: number) => (
                                            <tr className="segmentTableContent" key={index}>
                                                <td>{assignment.TPID}</td>
                                                <td>{assignment.Alias}</td>
                                                <td>{assignment.SegmentName}</td>
                                                <td>{assignment.RoleName}</td>
                                                <td>{assignment.Priority}</td>
                                            </tr>
                                        ))}
                                    </table>
                                     <p style={{ marginTop: '10px', fontStyle: 'italic' }}>
                                            Showing { assignmentsData.length < SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT  ? assignmentsData.length : SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT} of {assignmentsData.length} assignments. 
                                           
                                    {assignmentsData.length > SPA_PRERELEASE_ASSIGNMENTS_PREVIEW_LIMIT && (
                                        <>
                                        To get the complete list, please click Export.
                                        </>
                                    )}
                                        </p>
                                </>
                            );
                        })()}
                    </div>

                </div>
            )
        }

        if (areAssignmentsPublished && assignmentsData.length === 0) {
            return (
                <div className="cardContent">
                    <div style={{ marginBottom: '15px' }}>
                        <InlineStatus type="needs-attention">No assignments were generated</InlineStatus>
                    </div>
                    <p>Pre-release assignment generation completed but no assignments were created. This could be due to segment configuration or data availability.</p>
                    <Button 
                        appearance="secondary"
                        onClick={handleGenerateAssignments}
                        style={{ marginTop: '10px' }}
                    >
                        Retry Generation
                    </Button>
                </div>
            );
        }

        // Handle error state
        const errorInfo = campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE);
        if (errorInfo?.error) {
            return (
                <div className="cardContent">
                    <div style={{ marginBottom: '15px' }}>
                        <InlineStatus type="error">Generation failed</InlineStatus>
                    </div>
                    <MessageBar>
                        Error: {errorInfo.error}
                    </MessageBar>
                    <Button 
                        appearance="secondary"
                        onClick={handleGenerateAssignments}
                        style={{ marginTop: '10px' }}
                    >
                        Retry Generation
                    </Button>
                </div>
            );
        }

        return (
            <div className="cardContent">
                <MessageBar>
                    Pre-release assignments status is unknown. Please check the campaign configuration.
                </MessageBar>
            </div>
        );
    };

    useEffect(() => {
        setIsDeploy(
            subwayStatus.datasetValidationState === ValidationState.valid &&
            subwayStatus.segmentValidationState === ValidationState.valid && 
            subwayStatus.sequenceValidationState === ValidationState.valid
        );
    }, [setIsDeploy, subwayStatus.datasetValidationState, subwayStatus.segmentValidationState, subwayStatus.sequenceValidationState]);

    const renderAssignmentRules = (assignmentRules: any, status?: ValidationState) => {
        if (ValidationState.loading === status) {
            return <InlineStatus type="in-progress">Loading...</InlineStatus>;
        } else if (ValidationState.failed === status) {
            return <InlineStatus type="error">Couldn't find any assignment rule</InlineStatus>;
        }
        return (
            Object.keys(assignmentRules || {}).map((ruleName) => {
                const count = assignmentRules[ruleName];
                return <InlineStatus type={count > 0 ? "complete" : "error"}>{ruleName} <b>: {count}</b></InlineStatus>;
            })
        );
    }

    return (
        <div style={{display: 'flex'}}>
            <Subway label="Publishing Status" orientation="vertical" style={{flexGrow: 1, maxWidth: '500px', minWidth: "450px"}}>
                {
                    env === 'ALL' &&
                    <SubwayStop status={releaseStatus === "Deployed" ? 'complete' : 'not_started'}>
                        {releaseStatus === "Deployed" ? "Deployed" : "Not Deployed yet"}
                    </SubwayStop>
                }
                <SubwayStop status={subwayStatus.datasetValidationState === ValidationState.valid ? 'complete' : subwayStatus.datasetValidationState}>
                    Campaign Dataset
                    <div slot="details">
                        {(subwayStatus.datasetValidationState === ValidationState.valid) && "Dataset's are valid and Published"}
                        {subwayStatus.datasetValidationState === ValidationState.loading && "Loading..."}
                        {subwayStatus.datasetValidationState === ValidationState.invalid && (
                            subwayStatus.inValidDatasets.length > 0 ? "Invalid Dataset's: " + subwayStatus.inValidDatasets.join(", ") : "Dataset's not found"
                        )}
                        {subwayStatus.datasetValidationState === ValidationState.failed && "Unable to Validate Dataset's"}
                    </div>
                </SubwayStop>
                <SubwayStop status={subwayStatus.segmentValidationState}>
                    Campaign Segment's
                    <div slot="details">
                        {subwayStatus.segmentValidationState === ValidationState.loading && "Loading..."}
                        {subwayStatus.segmentValidationState === ValidationState.invalid && "Segments are not valid"}
                        {subwayStatus.segmentValidationState === ValidationState.failed && "Unable to Validate Segments"}
                        {subwayStatus.segmentValidationState === ValidationState.valid && "Found valid segment's "}
                        {subwayStatus.segments.length > 0 && sectionViewState !== SectionView.segmentView && <Button appearance="link" style={{marginTop: '-5px'}} onClick={() => setSectionView(SectionView.segmentView)}>See details</Button>}
                    </div>
                </SubwayStop>
                <SubwayStop status={subwayStatus.sequenceValidationState}>
                    Campaign Sequence's
                    <div slot="details">
                        {subwayStatus.segmentValidationState === ValidationState.loading && "Loading..."}
                        {subwayStatus.sequenceValidationState === ValidationState.invalid && "Sequence are not valid or not attached"}
                        {subwayStatus.sequenceValidationState === ValidationState.failed && "Unable to Validate Sequence's"}
                        {subwayStatus.sequenceValidationState === ValidationState.valid && "Found valid Sequence's"}
                    </div>
                </SubwayStop>
                {
                    env === 'ALL' &&
                    <>
                        <SubwayStop status={
                            ValidationWorkflowStatus === 0 ? 'not_started' : 
                            ValidationWorkflowStatus === 1 ? 'warning' :
                            ValidationWorkflowStatus === 2 ? 'progress' : 
                            ValidationWorkflowStatus === 3 ? 'complete' : 'error'
                        }>
                            ASPA validation workflow
                            <div slot="details">
                                {
                                    ValidationWorkflowStatus === 0 ? "Campaign Not deployed yet" :
                                    ValidationWorkflowStatus === 1 ? "ASPA Validation workflow hasn't succeeded since deployment" :
                                    ValidationWorkflowStatus === 2 ? "ASPA Validation workflow is In-Progress" :
                                    ValidationWorkflowStatus === 3 ? "ASPA Validation workflow has completed successfully" : 
                                    "ASPA Validation workflow hasn't processed " + (ValidationStatus.error || "")
                                }
                            </div>
                        </SubwayStop>
                        <SubwayStop status={
                            PreProcessingWorkflowStatus === 0 ? 'not_started' : 
                            PreProcessingWorkflowStatus === 1 ? 'warning' :
                            PreProcessingWorkflowStatus === 2 ? 'progress' : 
                            PreProcessingWorkflowStatus === 3 ? 'complete' : 'error'
                        }>
                            ASPA Pre-processing workflow
                            <div slot="details">
                                {
                                    PreProcessingWorkflowStatus === 0 ? "Campaign Not deployed yet" :
                                    PreProcessingWorkflowStatus === 1 ? "ASPA Pre-Processing workflow hasn't succeeded since deployment" :
                                    PreProcessingWorkflowStatus === 2 ? "ASPA Pre-Processing workflow is In-Progress" :
                                    PreProcessingWorkflowStatus === 3 ? "ASPA Pre-Processing workflow has completed successfully" : 
                                    "ASPA Pre-Processing workflow hasn't processed " + (PreProcessingStatus.error || "")
                                }
                            </div>
                        </SubwayStop>
                        <SubwayStop status={
                            releaseStatus !== "Deployed" || ValidationWorkflowStatus !== 3 || PreProcessingWorkflowStatus !== 3 ? "not_started" :
                            subwayStatus.segmentValidationState === ValidationState.loading || subwayStatus.recsStatus === ValidationState.loading ? "progress" :
                            !allNebulaWorkflowValidation ? "warning" :
                            allNebulaWorkflowValidation && subwayStatus.recommendations.generated === 0 && hasNebulaDelayed(modifiedOn) ? "error" :
                            allNebulaWorkflowValidation && subwayStatus.recommendations.generated === 0 ? "progress" : "complete"
                        }>
                            Nebula workflows
                            <div slot="details">
                                {   
                                    releaseStatus !== "Deployed" || ValidationWorkflowStatus !== 3 || PreProcessingWorkflowStatus !== 3 ? "Workflow's not started yet" :
                                    subwayStatus.segmentValidationState === ValidationState.loading || subwayStatus.recsStatus === ValidationState.loading ? "Loading..." :
                                    !allNebulaWorkflowValidation ? "Found validation error's for the Campaign" :
                                    allNebulaWorkflowValidation && subwayStatus.recommendations.generated === 0 && hasNebulaDelayed(modifiedOn) ? "There could be Nebula failures, Please reach out to support channels" :
                                    allNebulaWorkflowValidation && subwayStatus.recommendations.generated === 0 ? ("Workflow's are in progress, " + getNextETA(modifiedOn)) : "No Nebula failures found"
                                }
                            </div>
                        </SubwayStop>
                        <SubwayStop status={isCampaignHasRecs ? subwayStatus.recsStatus : "not_started"}>
                            Recommendations
                            <div slot="details">{isCampaignHasRecs ? "Recommendations are generated for this campaign." : "No Recommendations found yet." }</div>
                            {/* <div slot="details">
                                {
                                    (!isCampaignHasRecs || subwayStatus.recsStatus === 'not_started') ? "Recommendations are not generated yet" :
                                    sectionViewState === SectionView.recsView ? "See details" :
                                    <Button appearance="link" onClick={() => setSectionView(SectionView.recsView)}>See details</Button>
                                }
                            </div> */}
                        </SubwayStop>
                        <SubwayStop status={
                            !isCampaignHasRecs ? "not_started" :
                            !campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE) ? "not_started" :
                            campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status === PreReleaseStatus.IN_PROGRESS ? "progress" :
                            campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status === PreReleaseStatus.PUBLISHED ? "complete" :
                            campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.error ? "error" : "not_started"
                        }>
                            Pre-Release Assignments
                            <div slot="details">
                                {!isCampaignHasRecs ? "Recommendations need to be generated first" :
                                !campaign?.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE) ? "Assignments not initiated" :
                                campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status === PreReleaseStatus.IN_PROGRESS  ? "Assignment generation in progress" :
                                campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.status === PreReleaseStatus.PUBLISHED ? "Assignments generated successfully" :
                                campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.error ? `Error: ${campaign.preReleaseInfo.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)?.error}` :
                                "Click to view assignment details"
                                }
                                {isCampaignHasRecs && sectionViewState !== SectionView.preReleaseAssignmentsView && (
                                    <Button appearance="link" style={{marginTop: '-5px'}} onClick={() => setSectionView(SectionView.preReleaseAssignmentsView)}>
                                        See details
                                    </Button>
                                )}
                            </div>
                        </SubwayStop>
                    </>
                }
            </Subway>

            <div style={{flexDirection: 'column'}}>
            <Card className={'cardView'} style={{display: sectionViewState === SectionView.segmentView ? 'block' : 'none'}}>
                <span slot="heading">
                    Segments and Sequences
                </span>
                <div className="cardContent" >
                    {
                        subwayStatus.segmentValidationState === ValidationState.loading ? <InlineStatus type="in-progress">Loading...</InlineStatus>
                        :
                        subwayStatus.segments.length === 0 ? <div className="noSegmentFound"><InlineStatus type="error">No matching Segments found</InlineStatus></div>
                        :
                        <>
                            Found below {subwayStatus.segments.length > 1 ? "matching Segments" : "segment"} for the campaign at MSX
                            <table className="segmentTableHeader">
                                <tr>
                                    <th>Segment Name</th>
                                    <th>Assignment Rule: Users found</th>
                                    <th>Attached Sequence</th>
                                </tr>
                                {
                                    subwayStatus.segments.map((segment, index) => {
                                        return (
                                            <tr className="segmentTableContent">
                                                <td>{segment.segmentName}</td>
                                                <td>{
                                                    renderAssignmentRules(subwayStatus.assignmentRules[segment.segmentName], subwayStatus.assignmentRuleStatus[segment.segmentName])
                                                }</td>
                                                <td>{
                                                    segment.sequence !== undefined ? 
                                                    <InlineStatus type="complete">{segment.sequence}</InlineStatus> : 
                                                    <InlineStatus type="error">Sequence not attached</InlineStatus>
                                                }</td>
                                            </tr>
                                        )
                                    })
                                }
                            </table>
                        </>
                    }
                </div>
                <div >
                    </div>
            </Card>
            
            
            {/*<Card className={'cardView'} style={{display: sectionViewState === SectionView.segmentView ? 'block' : 'none', marginTop: '15px'}}>
            <div slot="heading" style={{display:'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span>Pipeline Information</span>
                <span style={{color:aboveTarget?'green':'red', fontWeight:'bold'}}>{aboveTarget?"Above Target":"Below Target"}</span>
            </div>
            <div className="cardContent">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span><InlineStatus>Targeted Pipeline:</InlineStatus>  </span>
                    <span>{targetedPipeline}</span>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span><InlineStatus>Generated Pipeline:  </InlineStatus></span>
                    <span>{subwayStatus.pipeline?.total_potential_rev_base}</span>
                </div>
            </div>
            </div>
            </Card> */}
            </div>
            <Card className={'cardView'} style={{display: sectionViewState === SectionView.recsView ? 'block' : 'none'}}>
                <span slot="heading">
                    Recommendations
                </span>
                <div className="cardContent">
                    <table className="RecsInfoTable">
                        <tr>
                            <td><InlineStatus type="complete">Total records uploaded to Datacart</InlineStatus></td>
                            <td>{inCartLength}</td>
                        </tr>
                        <tr>
                            <td><InlineStatus type={subwayStatus.recommendations.generated > 0 ? "complete" : "error"}>Total Generated Recommendations </InlineStatus></td>
                            <td>{subwayStatus.recommendations.generated}</td>
                        </tr>
                        <tr>
                            <td><InlineStatus type={subwayStatus.recommendations.unassigned === 0 ? "complete" : "needs-attention"}>Recommendations assigned to <i># Nebula-Integration-User</i></InlineStatus></td>
                            <td>{subwayStatus.recommendations.unassigned}</td>
                        </tr>
                        <tr><td><br/></td></tr>
                        <tr className="needBorder">
                            <th>Segmentation Info</th>
                            <th>Rec's Count</th>
                        </tr>
                        {
                            Object.keys(subwayStatus.recommendations.segmentInfo).filter(sn => sn !== "Unsegmented").map((segmentName) => {
                                return <tr className="needBorder">
                                    <td><InlineStatus type="complete">{segmentName}</InlineStatus></td>
                                    <td>{subwayStatus.recommendations.segmentInfo[segmentName]}</td>
                                </tr>;
                            })
                        }
                        <tr className="needBorder">
                            <td><InlineStatus type={subwayStatus.recommendations.segmentInfo['Unsegmented'] > 0 ? "unknown" : "complete"}>Unsegmented</InlineStatus></td>
                            <td>{subwayStatus.recommendations.segmentInfo['Unsegmented']}</td>
                        </tr>
                    </table>
                </div>
            </Card>
            <Card 
                className={'cardView'} 
                style={{
                    display: sectionViewState === SectionView.preReleaseAssignmentsView ? 'block' : 'none',
                    marginTop: '15px'
                }}
            >
                <div slot="heading" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Pre-Release Assignments</span>
                    {assignmentsStatus === "Published" && (
                        <span style={{ color: 'green', fontWeight: 'bold', fontSize: '5px' }}>
                        <Button appearance="command" 
                                onClick={handleDownloadAssignments} 
                                
                            >
                                {/* <Icon name="info" style={{ fontSize: '16px', color: '#0078d4', cursor: 'help' }} />
                                <Tooltip> Download the complete list of all pre-release assignments" </Tooltip> */}

                                <Icon slot="start" name="excellogo"></Icon>Export to Excel
                        </Button>
                     
                        </span>

                    )}
                </div>
                {renderPreReleaseAssignmentCardContent()}
            </Card>
        </div>
    )
}

const ReleaseLiveDashboardC: React.FC<ILiveDashboardProps> = (props: ILiveDashboardProps) => {

    const location = useLocation();
    const { workflowName } = location.state;

    const releaseDashboard = useSelector((state: RootState) => state.releaseDashboard);
    const userSalesRoles = useSelector((state: RootState) => state.userSalesRoles);

    const [isDeploy, setIsDeploy] = useState(true);
    const [expanded, setExpansion] = useState(props.env === 'DEV' ? 1 : (props.env === 'UAT' || props.env === 'ALL') ? 2 : 3);

    const currentVersion = releaseDashboard.uatStatus.version
    const devReleaseStatus = props.releaseRows.find((x:any) => x.cells.field1 === currentVersion)?.cells.field2;
    const uatReleaseStatus = props.releaseRows.find((x:any) => x.cells.field1 === currentVersion)?.cells.field3;
    const prodReleaseStatus = props.releaseRows.find((x:any) => x.cells.field1 === currentVersion)?.cells.field4;

    const devConfiguration: Campaign = useSelector((state: RootState) => state.releaseData.devConfiguration);
    const uatConfiguration: Campaign = useSelector((state: RootState) => state.releaseData.uatConfiguration);
    const prodConfiguration: Campaign = useSelector((state: RootState) => state.releaseData.prodConfiguration);

        const dispatch = useDispatch();

useEffect(() => {
    if (uatConfiguration.preReleaseInfo?.find(info => info.type === SPA_PRERELEASE_ASSIGNMENTS_TYPE)) {
        dispatch(getPreReleaseAssignments_uat(uatConfiguration.config.workflowId) as any);
    }
}, [uatConfiguration]);
    return (
        <Dialog
            heading={`Campaign Live Dashboard | ${workflowName} (V${currentVersion}.0)`}
            className={'live-dashboard-dialog'}
            open={props.viewState}
            onHeAfterHide={() => {props.setViewState(false)}}
        >        
            <Accordion expand-mode="single">
                {!userSalesRoles.isApprover && !userSalesRoles.isSpaUser && (props.env === 'ALL' || props.env === 'DEV') &&
                    <AccordionItem expanded={expanded === 1} onClick={() => setExpansion(1)}>
                        <span slot="heading">Dev - Release Status</span>
                        {RenderSubwayStatus(props.env,devConfiguration, releaseDashboard.devStatus, setIsDeploy, new Date(devConfiguration.modifiedDate), (devConfiguration.inCart || []).length, devConfiguration.postDeployInfo, devReleaseStatus)}
                    </AccordionItem>
                }
                {(props.env === 'ALL' || props.env === 'UAT') &&
                    <AccordionItem expanded={expanded === 2} onClick={() => setExpansion(2)}>
                        <span slot="heading">UAT - Release Status</span>
                        {RenderSubwayStatus(props.env, uatConfiguration,releaseDashboard.uatStatus, setIsDeploy,  new Date(uatConfiguration.modifiedDate), (uatConfiguration.inCart || []).length, uatConfiguration.postDeployInfo, uatReleaseStatus)}
                    </AccordionItem>
                }
                {(props.env === 'ALL' || props.env === 'PROD') &&
                    <AccordionItem expanded={expanded === 3} onClick={() => setExpansion(3)}>
                        <span slot="heading">Prod - Release Status</span>
                        {RenderSubwayStatus(props.env, prodConfiguration,releaseDashboard.prodStatus, setIsDeploy,  new Date(prodConfiguration.modifiedDate), (prodConfiguration.inCart || []).length, prodConfiguration.postDeployInfo, prodReleaseStatus)}
                    </AccordionItem>
                }
            </Accordion>
            
            {
                /* footer code */
                props.buttonText && props.env !== 'ALL' && 
                <>
                    <Divider slot="footer"/>
                    <Button slot="footer" style={{"marginRight":"20px", "marginTop": "10px"}} appearance="primary" 
                        disabled={!isDeploy}
                        onClick={() => {
                            props.setViewState(false);
                            props.onDeploy && props.onDeploy();
                        }}
                    >
                        {props.buttonText}
                    </Button>
                </>
            }
        </Dialog>
    );
};
export const ReleaseLiveDashboard = withErrorBoundary("ReleaseLiveDashboard", ReleaseLiveDashboardC);